import { forwardRef, useColorModeValue } from "@chakra-ui/react"
import { MotionBox, MotionBoxProps } from "component/Motion"
import { Link } from "react-router-dom"
export interface CardProps extends MotionBoxProps {
    to?: string
}

const Card = forwardRef<CardProps, "div">((props, ref) => {
    const { to, children, ...cardProps } = props
    const linkProps = to ? { to, as: Link, display: "block" } : {}
    const cardBg = useColorModeValue("bottomSheetBg.light", "bottomSheetBg.dark")
    const borderColor = useColorModeValue("blackAlpha.100", "whiteAlpha.100")

    return (
        <MotionBox
            ref={ref}
            borderColor={borderColor}
            bg={cardBg}
            position="relative"
            boxSizing="border-box"
            boxShadow="sm"
            overflow="hidden"
            w="full"
            borderRadius={["2xl"]}
            p={6}
            sx={{ breakInside: "avoid" }}
            {...linkProps}
            {...cardProps}
        >
            {children}
        </MotionBox>
    )
})

export { Card }
